// «شجرة الحسابات» inside the settings module (HANDOFF §3: /settings/coa ·
// board settings/coa). Owner only — the whole الإعدادات module is owner-only
// (HANDOFF §9) — and part of the accounts product (flag erp.accounts): off ⇒
// absent from the menu and routes; a deep link lands on «اليوم» with the reason.
//
// Wiring (integrator): spread `coaRoutes` into settings/index.tsx `routes` and
// `coaMenu` into its `menu` (HANDOFF §3 order: … ساعات العمل · شجرة الحسابات ·
// سجل التدقيق …). The mock for /erp/coa is served by the accounts module's
// fake ledger (src/features/accounts/ledger/mock) — one set of books.

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';

export const COA_PATH = '/settings/coa';

const g = gate({ flag: 'erp.accounts', minRole: 'owner' });

export const coaRoutes: RouteObject[] = [
  { path: COA_PATH, lazy: () => import('./screens/Coa').then((m) => ({ Component: m.CoaRoute })), handle: g },
];

export const coaMenu: MenuItem[] = [{ key: 'coa', label: 'شجرة الحسابات', to: COA_PATH, flag: 'erp.accounts', minRole: 'owner' }];
